<template>
 <div class='inline-block width_full'>
  <button
    type="button"
    :class='{"width_full": true, "primary-green-bg":!error, "red-bg":error}'
    @click="buttonAction">
    {{ buttonText || 'PROCEED' }}
  </button>
 </div>
</template>

<script>
  export default {
    props: {
      'buttonText': {
        required: false
      },
      'value': {
        required: false
      },
      'error': {
        required: false
      },
      'action': {
        required: false
      }
    },
    methods: {
      buttonAction () {
        this.$emit('input', '')
        if (typeof this.action === 'function') {
          this.action()
        }
      }
    }
  }
</script>

<style scoped>
button {
  font-size: 1.3rem;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// SingleButton.vue?95a7725e